import { Formik } from 'formik';
import { noop } from 'lodash';
import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';

export const itemSearchInStoreFormDefaultValues = {
  q: '',
};

const ItemSearchInStoreFormContext: FC = ({ children }) => {
  const [searchParams] = useSearchParams();
  const q = searchParams.get('q') || '';

  const initialValues = {
    ...itemSearchInStoreFormDefaultValues,
    q,
  };

  return (
    <Formik initialValues={initialValues} onSubmit={noop}>
      {children}
    </Formik>
  );
};

export default ItemSearchInStoreFormContext;
